import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { environment } from '@lsq-frontend/fasttrack-shared/environment';

import { AppModule } from './app/app.module';

if (environment.production) {
    enableProdMode();
}

// Load segment if it has been initalized and we have a key.
if ((window as any).analytics && environment.segmentKey) {
    (window as any).analytics.load(environment.segmentKey);
}

platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));
